module.exports = __webpack_public_path__ + "img/Stab.8b4f43fa.png";